module.exports = __webpack_public_path__ + "static/media/cart-icon.a9821ee0.svg";